import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export const resetDeletedBadgeCache = () => { cache = null; };
const load = () => Promise.all([
  api.get("/catalog/discontinued-variant-ids").then(({ data }) => new Set(data)).catch(() => new Set()),
  api.get("/catalog/deleted-variant-ids").then(({ data }) => new Set(data)).catch(() => new Set()),
]);
// ID-050 / ID-073: marks historical lines whose variant was archived (discontinued) or permanently deleted
export function DiscontinuedBadge({ variantId }) {
  const [sets, setSets] = useState(null);
  useEffect(() => {
    if (!cache) { cache = load(); }
    cache.then(setSets);
  }, []);
  if (!sets) return null;
  const [archived, deleted] = sets;
  if (deleted.has(variantId)) return <span className="ml-2 badge-status badge-neutral" data-testid={`product-deleted-${variantId}`}>Product deleted</span>;
  if (!archived.has(variantId)) return null;
  return <span className="ml-2 badge-status badge-neutral" data-testid={`discontinued-${variantId}`}>discontinued</span>;
}
